import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {NolimitPlugin} from "@nolimitcity/slot-launcher/bin/NolimitPlugin";
import {Logger, LogLevel} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {GameFlowController} from "@nolimitcity/slot-game/bin/flowcontrol/GameFlowController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {FlowState} from "@nolimitcity/slot-game/bin/flowcontrol/FlowState";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FontLoader} from "@nolimitcity/slot-launcher/bin/loader/FontLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {AssetsConfig} from "@nolimitcity/slot-game/bin/asset/AssetsConfig";
import {AssetLoader} from "@nolimitcity/slot-game/bin/asset/AssetLoader";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/asset/ResourcesGroupName";
import {TheRaveGameAssets} from "./TheRaveGameAssets";
import {TheRaveSound} from "./sound/TheRaveSound";
import {TheRaveBackground} from "./view/TheRaveBackground";
import {TheRaveWinPresentation} from "./gameflow/TheRaveWinPresentation";
import {TheRaveNormalBetPresentation} from "./gameflow/TheRaveNormalBetPresentation";
import {TheRaveNormalResultPresentation} from "./gameflow/TheRaveNormalResultPresentation";
import {TheRaveNormalIdlePresentation} from "./gameflow/TheRaveNormalIdlePresentation";
import {TheRaveModel} from "./server/TheRaveModel";
import {TheRaveReelController} from "./reels/TheRaveReelController";
import {TheRaveGameConfig} from "./TheRaveGameConfig";
import {ReelStopPresentationManager} from "./reelstoppresentation/ReelStopPresentationManager";
import {ReelStopSoundController} from "./reelstoppresentation/presentations/ReelStopSoundController";
import {WinPresentationManager} from "./winpresentation/WinPresentationManager";
import {Ways} from "./view/Ways";
import {TheRaveGameMode} from "./gameflow/TheRaveGameMode";
import {XSplitController} from "./winpresentation/presentations/XSplitController";
import {NoWinSymbolsController} from "./winpresentation/presentations/NoWinSymbolsController";
import {BetWaysInitialWinController} from "./winpresentation/presentations/initial/BetWaysInitialWinController";
import {InitialWinCountUp} from "./winpresentation/presentations/initial/InitialWinCountUp";
import {WaysWonCountUp} from "./winpresentation/presentations/initial/WaysWonCountUp";
import {BigWinController} from "./winpresentation/presentations/bigwin/BigWinController";
import {BigWinCountUp} from "./winpresentation/presentations/bigwin/BigWinCountUp";
import {IndividualWinController} from "./winpresentation/individual/IndividualWinController";
import {FreespinIntro} from "./screen/FreespinIntro";
import {FreespinWinController} from "./winpresentation/presentations/FreespinWinController";
import {TheRaveFreespinIdlePresentation} from "./gameflow/TheRaveFreespinIdlePresentation";
import {FreespinOutro} from "./screen/FreespinOutro";
import {FreespinEndController} from "./winpresentation/presentations/FreespinEndController";
import {WinCapScreen} from "./screen/WinCapScreen";
import {BreakBankController} from "./winpresentation/presentations/BreakBankController";
import {SuperFsWinController} from "./winpresentation/presentations/SuperFsWinController";
import {TheRaveSuperFsResultPresentation} from "./gameflow/TheRaveSuperFsResultPresentation";
import {Layers, TheRaveLayers} from "./view/TheRaveLayers";
import {XWaysExpansion} from "./winpresentation/presentations/XWaysExpansion";
import {StickySymbol} from "./stickysymbol/StickySymbol";
import {FreespinM1MultiplierReveal} from "./winpresentation/presentations/FreespinM1MultiplierReveal";
import {FreespinNoWinPause} from "./winpresentation/presentations/FreespinNoWinPause";
import {SymbolLandingAnimationController} from "./reelstoppresentation/presentations/SymbolLandingAnimationController";
import {ReplaceSPSymbols} from "./winpresentation/presentations/ReplaceSPSymbols";
import {WinsHighLight} from "./reelstoppresentation/presentations/WinsHighLight";
import {AudioVisualiser} from "./view/AudioVisualiser";
import {XWaysController} from "./xways/XWaysController";
import {ScatterController} from "./scattercontroller/ScatterController";
import {NearWinPresentation} from "./view/NearWinPresentation";
import {TheRaveEnhancerReelController} from "./reels/TheRaveEnhancerReelController";
import {TheRaveFSBetPresentation} from "./gameflow/TheRaveFSBetPresentation";
import {FullScreenDimLayer} from "./view/FullScreenDimLayer";
import {TransformLowToWild} from "./winpresentation/presentations/TransformLowToWild";
import {XwaysEqView} from "./view/XwaysEqView";
import {DoubleXways} from "./winpresentation/presentations/DoubleXways";
import {TransformMsToDJ} from "./winpresentation/presentations/TransformMsToDJ";
import {RandomFeatureSign} from "./view/RandomFeatureSign";
import {ReelHighlighter} from "./view/ReelHighlighter";
import {AllReelStopped} from "./reelstoppresentation/presentations/AllReelStopped";
import {TemplateAsset, TemplateLoader} from "@nolimitcity/slot-launcher/bin/loader/TemplateLoader";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";
import {APIFeatureBetEventData} from "@nolimitcity/slot-launcher/bin/interfaces/APIBetEventData";
import {TheRaveSymbol} from "./symbol/TheRaveSymbol";
import {TheRaveSymbolState} from "./symbol/TheRaveSymbolConfig";
import {FSPlus} from "./view/FSPlus";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {ReelState} from "../core/reel/ReelState";

export class TheRave extends SlotGame {
    public static model: TheRaveModel;
    public static gameFlowController: GameFlowController;
    public static assetLoader: AssetLoader;
    public static reels: TheRaveReelController[];
    public static enhancerReels: TheRaveEnhancerReelController[];
    public static reelStopPresentations: ReelStopPresentationManager;
    public static winPresentations: WinPresentationManager;
    public static background: TheRaveBackground;
    public static ways: Ways;
    public static initialCountUp: InitialWinCountUp;
    public static waysWon: WaysWonCountUp;
    public static bigWinCountUp: BigWinCountUp;
    public static individualWin: IndividualWinController;
    public static freespinIntro: FreespinIntro;
    public static freespinOutro: FreespinOutro;
    public static winCapScreen: WinCapScreen;
    public static stickySymbol: StickySymbol;
    public static XWaysController: XWaysController;
    public static scatterController: ScatterController;
    public static nearwinPresentation: NearWinPresentation;
    public static audioVisualiser: AudioVisualiser;
    public static fullScreenDimLayer: FullScreenDimLayer;
    public static xwaysEqView: XwaysEqView;
    public static randomFeatureSign: RandomFeatureSign;
    public static reelHighlighter: ReelHighlighter;
    public static fsPlus: FSPlus;
    public static buyFeatureName: string = "";
    public static isActionSpinsActive: boolean = false;
    public static isNJServer :boolean=false;

    constructor() {
        super();
    }

    private static getBuyFeaturePrice(): number {
        const betLevel: string = TheRave.apiPlugin.freeBets.hasFreeBets() ? TheRave.apiPlugin.freeBets.getBet() : TheRave.apiPlugin.betLevel.getLevel();
        let price: number = parseInt(TheRave.model.gameData?.playedBetValue) || parseFloat(betLevel);
        if (TheRave.buyFeatureName) {
            for (let index: number = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheRave.model.initData.featureBuyTimesBetValue[index].name === TheRave.buyFeatureName) {
                    price *= TheRave.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        if (TheRave.model.gameData?.boostedBetPlayed) {
            for (let index: number = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                if (TheRave.model.initData.featureBuyTimesBetValue[index].name === "BOOSTED_BET") {
                    price *= TheRave.model.initData.featureBuyTimesBetValue[index].price;
                }
            }
        }
        return price;
    }

    private static getAccumulatedRoundWin(): number {
        if (TheRave.model.parsedGameData) {
            return TheRave.model.parsedGameData.totalWin;
        }
        return TheRave.model.parsedInitData.totalWin;
    }

    public static isWinBelowStake(): boolean {
        const featurePrice:number = this.getBuyFeaturePrice(),
            win:number = this.getAccumulatedRoundWin();
        const winBelowStake: boolean = TheRave.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (win <= featurePrice);
        //console.log("winBelowStake: " + winBelowStake);
        return winBelowStake;
    }

    public getSymbolString(key: string, data: { 3: number, 4: number, 5: number }): string {
        return `
            <div class="symbol">
            <img src="{{gamePath}}screens/images/symbols/${key}.png">
            <div class="payout-group">
                <div class="payout">
                    <span class="number">5</span>
                    <span class="multiplier" data-multiplier="${data[5] * 0.05}">${data[5] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">4</span>
                    <span class="multiplier" data-multiplier="${data[4] * 0.05}">${data[4] * 0.05}</span>
                </div>
                <div class="payout">
                    <span class="number">3</span>
                    <span class="multiplier" data-multiplier="${data[3] * 0.05}">${data[3] * 0.05}</span>
                </div>
            </div>
            </div>
        `;


    }

    public getPaytable(): Promise<string> {
        //const templateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot());

        const templateLoader: TemplateLoader = new TemplateLoader(SlotGame.apiPlugin.resources.getStaticRoot()),
            data = {
                boostedBetAllowed: TheRave.apiPlugin.gameClientConfiguration.boostedBetAllowed,
                replaceWincapInfo: TheRave.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showLowProbabilityGfx: TheRave.apiPlugin.gameClientConfiguration.showLowProbabilityGfx
            };

        templateLoader.add({
            name: "Paytable",
            url: "nolimit/screens/paytable.mustache"
        });


        let symbolDataValueData = TheRaveGameConfig.DEFAULT_SYMBOL_VALUES;
        if (TheRave.model?.symbolValues) {
            symbolDataValueData = TheRave.model?.symbolValues;
        }

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name == "Paytable" && asset.loadedData) {

                    for (let key in symbolDataValueData) {
                        asset.loadedData = asset.loadedData.replace(`{{${key}}}`, this.getSymbolString(key, symbolDataValueData[key]))
                    }
                    return asset.loadedData;
                }
            }
            throw new Error("SlotGame could not load Paytable");
        }).then((value: string) => {
            return TheRave.apiPlugin.translations.render(value, data);
        });
    }

    public init(): Promise<NolimitPlugin> {
        return super.init().then((value: NolimitPlugin) => {
            TheRave.model = new TheRaveModel(SlotGame.apiPlugin, true);
            TheRave.gameFlowController = new GameFlowController(SlotGame.apiPlugin, TheRave.model);
            TheRave.gameFlowController.flowStateLogger.level = LogLevel.DEV;
            TheRave.apiPlugin.events.once("featureName", (data: string) => {
                TheRave.buyFeatureName = data;
            });

            TheRave.isNJServer = !!(SlotKeypad.apiPlugIn.options && SlotKeypad.apiPlugIn.options.game && SlotKeypad.apiPlugIn.options.game.indexOf("NJ") > -1);
            /*TheRave.apiPlugin.events.on(APIEvent.BET, (betData: APIFeatureBetEventData) => {
                for (let index = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                    if (TheRave.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                        TheRave.buyFeatureName = betData.featureName;
                        Logger.logDev("Opted Feature : ", TheRave.buyFeatureName);
                        break;
                    }
                }
            });*/
            TheRave.apiPlugin.events.on(APIEvent.ACTION_SPINS_BET, (betData: APIFeatureBetEventData) => {
                for (let index = 0; index < TheRave.model.initData.featureBuyTimesBetValue.length; index++) {
                    if (TheRave.model.initData.featureBuyTimesBetValue[index].name === betData.featureName) {
                        TheRave.buyFeatureName = betData.featureName;
                        Logger.logDev("Opted Feature : ", TheRave.buyFeatureName);
                        break;
                    }
                }
            });

            const normalIdle = new TheRaveNormalIdlePresentation();
            const normalBet = new TheRaveNormalBetPresentation();
            const fsBet = new TheRaveFSBetPresentation();
            const normalResult = new TheRaveNormalResultPresentation();
            const winPres = new TheRaveWinPresentation();

            const freespinIdle = new TheRaveFreespinIdlePresentation();
            const superFsResult = new TheRaveSuperFsResultPresentation();

            TheRave.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.NORMAL, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, normalIdle],
                [FlowState.BET, normalBet],
                [FlowState.RESULT, normalResult],
                [FlowState.WIN, winPres]
            ]));
            TheRave.gameFlowController.addGameModeFlowStatePresentationMap(GameMode.FREESPIN, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinIdle],
                [FlowState.BET, fsBet],
                [FlowState.RESULT, superFsResult],
                [FlowState.WIN, winPres]
            ]));
            TheRave.gameFlowController.addGameModeFlowStatePresentationMap(TheRaveGameMode.FREESPIN_SUPER, new Map<FlowState, FlowStatePresentation>([
                [FlowState.IDLE, freespinIdle],
                [FlowState.BET, fsBet],
                [FlowState.RESULT, superFsResult],
                [FlowState.WIN, winPres]
            ]));

            return value;
        });
    }

    public async getReady(): Promise<NolimitPlugin> {
        //Show intro and load game assets
        const value = await super.getReady();

        const fontLoader = new FontLoader(NolimitApplication.resourcePath);
        fontLoader.add(OpenSans.ITALIC_600);
        fontLoader.add(OpenSans.NORMAL_300);
        fontLoader.add(OpenSans.NORMAL_400);
        fontLoader.add(OpenSans.NORMAL_700);

        AssetsConfig.addToAssetsConfig(TheRaveGameAssets.RESOURCES_GROUPS);
        TheRave.assetLoader = new AssetLoader(TheRave.apiPlugin, NolimitApplication.resourcePath + "/resources/");

        await Promise.all([fontLoader.load(), TheRave.assetLoader.load(ResourcesGroupName.MAIN)]);
        await this.createViewsAndComponents();
        if(TheRave.apiPlugin.gameClientConfiguration.useCensoredGfxUS) {
            this.addPayTableReplaceListener();
            this.loadAndReplaceAssets(value, "resources/images/");
        }
        return value;
    }


    public loadAndReplaceAssets(value:NolimitPlugin, path:string){
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("FREESPIN_5_SCATTERS_rep", path + "FREESPIN_5_SCATTERS.png");
        imgLoader.add("LUCKY_DRAW_rep", path + "LUCKY_DRAW.png");

        const replaceList = [
            "FREESPIN_5_SCATTERS_rep",
            "LUCKY_DRAW_rep"
        ]
        const promises = Promise.all([ imgLoader.load()]);
        return promises.then((values: any) => {
            for (let replaceName of replaceList) {
                let baseTextureNew:PIXI.BaseTexture = PIXI.utils.BaseTextureCache[replaceName];
                const realName = replaceName.replace("_rep", "");
                if(PIXI.utils.TextureCache[realName]) {
                    const newTexture = PIXI.utils.TextureCache[replaceName];
                    const texture = PIXI.utils.TextureCache[realName];
                    texture.baseTexture = baseTextureNew;
                    texture.frame = newTexture.frame;
                    texture.trim = newTexture.trim;
                    texture.updateUvs();
                }
            }
            return value;
        });
    }

    private addPayTableReplaceListener(){
        TheRave.apiPlugin.events.on("screen", (data:string)=> {
            if (data == "open") {
                const gameInfo = document.getElementById("gameInfoContainer");
                const bonus = gameInfo?.getElementsByClassName("noLimitBonus")[0];
                if(bonus) {
                    const elements = bonus.getElementsByClassName("buyFeatureImage")
                    for (let element of elements){
                        if ((<HTMLImageElement>element).alt === "FREESPIN_5_SCATTERS" || (<HTMLImageElement>element).alt === "LUCKY_DRAW") {
                            (<HTMLImageElement>element).src = NolimitApplication.resourcePath + "/resources/images/" + (<HTMLImageElement>element).alt + ".png"
                        }
                    }
                }
            }
        });

    }

    public async getReadyToStart(): Promise<NolimitPlugin> {
        //Game assets loaded, showing intro, waiting for user to start game


        return await super.getReadyToStart();
    }

    public async start(): Promise<NolimitPlugin> {
        //User has pressed continue and the game starts.
        const value = await super.start();

        TheRave.gameFlowController.start();
        if (TheRave.model.isRestore) {
            return value;
        }

        TheRaveSound.switchMusic({name: TheRaveSound.getMusicNameByMode(TheRave.model.currentParsedData.mode)});
        TheRave.background.updateEnvironment(TheRave.model.currentParsedData.mode);

        return value;
    }

    public getGameRules(): Promise<string> {
        const templateLoader: TemplateLoader = new TemplateLoader(TheRave.apiPlugin.resources.getStaticRoot()),
            data = {
                boostedBetAllowed: TheRave.apiPlugin.gameClientConfiguration.boostedBetAllowed,
                replaceSlotsInGameRules: TheRave.apiPlugin.gameClientConfiguration.replaceSlotsInGameRules,
                replaceWincapInfo: TheRave.apiPlugin.gameClientConfiguration.replaceWincapInfo,
                showBaseGameHighestWinInRules: TheRave.apiPlugin.gameClientConfiguration.showBaseGameHighestWinInRules
            };

        templateLoader.add({
            name: "Rules",
            url: "nolimit/screens/rules.mustache"
        });

        return templateLoader.load().then((assets: TemplateAsset[]) => {
            for (let asset of assets) {
                if (asset.name === "Rules" && asset.loadedData) {
                    return asset.loadedData;
                }
            }
            throw new Error("FolsomPrison could not load Rules");
        }).then((value: string) => {
            return TheRave.apiPlugin.translations.render(value, data);
        });
    }

    getNoWinGameData(): any {
        return {
            "reels": [
                [
                    "M5",
                    "M3",
                    "L5",
                    "M1",
                    "M3"
                ],
                [
                    "L5",
                    "M3",
                    "L3",
                    "L4",
                    "S"
                ],
                [
                    "L5",
                    "L3",
                    "L3",
                    "L2",
                    "L2"
                ],
                [
                    "M5",
                    "L3",
                    "L4",
                    "M1",
                    "L5"
                ],
                [
                    "M4",
                    "L5",
                    "M5",
                    "M3",
                    "M5"
                ]
            ],
            "evaluatedArea": [
                [
                    "M3",
                    "L5",
                    "M1"
                ],
                [
                    "M3",
                    "L3",
                    "L4"
                ],
                [
                    "L3",
                    "L3",
                    "L2"
                ],
                [
                    "L3",
                    "L4",
                    "M1"
                ],
                [
                    "L5",
                    "M5",
                    "M3"
                ]
            ],
            "betWayWins": [],
            "totalSpinWinnings": 0,
            "accumulatedRoundWin": 0,
            "playedBetValue": 1,
            "reelsNextSpin": "BASE_REELSET",
            "mode": "NORMAL",
            "nextMode": "NORMAL",
            "numberOfFreespinsPlayed": 0,
            "freespinsLeft": 0,
            "scatterPositions": [
                -1,
                -1,
                -1,
                -1,
                -1
            ],
            "symbolSizes": [
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0
                ]
            ],
            "mysterySymbolReveal": "",
            "freespinTriggeredThisSpin": false,
            "featureBuyTimesBetValue": [
                {
                    "name": "FREESPIN_3_SCATTERS",
                    "type": "FREESPIN",
                    "price": 68
                },
                {
                    "name": "FREESPIN_4_SCATTERS",
                    "type": "FREESPIN",
                    "price": 140
                },
                {
                    "name": "FREESPIN_5_SCATTERS",
                    "type": "FREESPIN",
                    "price": 522
                },
                {
                    "name": "LUCKY_DRAW",
                    "type": "FREESPIN",
                    "price": 202
                },
                {
                    "name": "BOOSTED_BET",
                    "type": "BOOSTED_BET",
                    "price": 1.2
                }
            ],
            "featureBet": false,
            "boostedBetPlayed": false,
            "totalWays": 243,
            "maximumWinAchieved": false,
            "nAdditionalFsAwarded": 0,
            "splitDataListxWays": [],
            "splitDataListxSplit": [],
            "freespinMidMultipliers": [
                0,
                0,
                0,
                0,
                0
            ],
            "nSC": 0,
            "nXways": 0,
            "doDoubleXways": [
                false,
                false,
                false,
                false,
                false
            ],
            "scatterEnhancers": [],
            "doTransformToM1": false,
            "doLowToWildReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "doLinkedReels": [
                false,
                false,
                false,
                false,
                false
            ],
            "midCoords": [],
            "lowCoords": []
        };
    }

    private createViewsAndComponents() {
        //Non views
        const sound = new TheRaveSound();
        const layers = new TheRaveLayers();
        //Views
        TheRave.background = new TheRaveBackground();
        TheRave.ways = new Ways();
        TheRave.initialCountUp = new InitialWinCountUp();
        TheRave.waysWon = new WaysWonCountUp();
        TheRave.bigWinCountUp = new BigWinCountUp(TheRaveLayers.getLayer(Layers.BIG_WIN_COUNT_UP)!, 700, 812);
        TheRave.reels = [];
        TheRave.enhancerReels = [];
        TheRave.stickySymbol = new StickySymbol();
        TheRave.randomFeatureSign = new RandomFeatureSign();
        TheRave.fullScreenDimLayer = new FullScreenDimLayer();
        TheRave.fsPlus = new FSPlus();
        for (let i: number = 0; i < TheRaveGameConfig.SPIN_REELS; i++) {
            if (i < 5) {
                TheRave.reels.push(new TheRaveReelController(i));
            } else {
                TheRave.enhancerReels.push(new TheRaveEnhancerReelController(i));
            }

        }
        TheRave.reelStopPresentations = new ReelStopPresentationManager([
            new ReelStopSoundController(),
            new AllReelStopped(),
            new WinsHighLight(),
            new SymbolLandingAnimationController()
        ]);
        TheRave.winPresentations = new WinPresentationManager([
            new ReplaceSPSymbols(),
            new XSplitController(),
            new XWaysExpansion(),
            new DoubleXways(),
            new TransformLowToWild(),
            new TransformMsToDJ(),
            //new UpdateSplitSymbols(),
            new FreespinM1MultiplierReveal(),
            new NoWinSymbolsController(),
            new FreespinNoWinPause(),
            new BetWaysInitialWinController(),
            new BigWinController(),
            new FreespinWinController(),
            new FreespinEndController(),
            new BreakBankController(),
            new SuperFsWinController()
        ]);
        TheRave.individualWin = new IndividualWinController();
        TheRave.freespinIntro = new FreespinIntro();
        TheRave.freespinOutro = new FreespinOutro();
        TheRave.winCapScreen = new WinCapScreen();
        TheRave.XWaysController = new XWaysController();
        TheRave.scatterController = new ScatterController();
        TheRave.nearwinPresentation = new NearWinPresentation();
        TheRave.reelHighlighter = new ReelHighlighter();

        TheRave.audioVisualiser = new AudioVisualiser(TheRaveLayers.getLayer(Layers.REEL_FRAME)!);
        TheRave.xwaysEqView = new XwaysEqView();

/*

         if (TheRave.apiPlugin.isReplay) {
             if (TheRave.model.nextPlayerInteraction?.featureName === "BOOSTED_BET") {
                 TheRave.reels[1].turnOnBoost(true);
             } else {
                 TheRave.reels[1].turnOffBoost(true);
             }
         } else if (TheRave.apiPlugin.freeBets.hasFreeBets()) {
            TheRave.reels[1].turnOffBoost(true);

            TheRave.apiPlugin.freeBets.events.once(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => {
                TheRave.reels[1].turnOffBoost(false);
            });
        } else if (TheRave.apiPlugin.freeFeatureBet.hasFreeFeatureBet()) {
            TheRave.model.isFreeBetFeatureBet = true;
            TheRave.reels[1].turnOffBoost(true);
            TheRave.apiPlugin.freeBets.events.once(SlotGame.apiPlugin.freeFeatureBet.FREE_FEATURE_BET_END, () => {
                TheRave.model.isFreeBetFeatureBet = false;
                TheRave.reels[1].turnOffBoost(false);
            });
        } else if (TheRave.model.isRestore && TheRave.model.initData.boostedBetPlayed) {
            TheRave.reels[1].turnOnBoost(false);
        }

        TheRave.apiPlugin.freeBets.events.on(SlotGame.apiPlugin.freeBets.FREE_BETS_START, () => {
            TheRave.reels[1].turnOffBoost(true);

            TheRave.apiPlugin.freeBets.events.once(SlotGame.apiPlugin.freeBets.FREE_BETS_END, () => {
                TheRave.reels[1].turnOffBoost(false);
            });
        });
*/
        TheRave.apiPlugin.promotionHandler.events.on(TheRave.apiPlugin.promotionHandler.FREE_FEATURE_BET_START, ()=>{
            TheRave.reels[1].hideBoostButton();
            TheRave.reels[1].reelView.betBoostPaused = true;
        });
        TheRave.apiPlugin.promotionHandler.events.on(TheRave.apiPlugin.promotionHandler.FREE_BETS_START, ()=>{
            TheRave.reels[1].hideBoostButton();
            TheRave.reels[1].reelView.betBoostPaused = true;
        });
        TheRave.apiPlugin.promotionHandler.events.on(TheRave.apiPlugin.promotionHandler.FREE_FEATURE_BET_END, ()=>{
            TheRave.reels[1].reelView.betBoostPaused = false;
            TheRave.reels[1].showBoostButton();
        });
        TheRave.apiPlugin.promotionHandler.events.on(TheRave.apiPlugin.promotionHandler.FREE_BETS_END, ()=>{
            TheRave.reels[1].reelView.betBoostPaused = false;
            TheRave.reels[1].showBoostButton();
        });
        // Double XW restore
        if (TheRave.model.isRestore) {
            (TheRave.model.doDoubleXways || []).forEach((bool, index) => {
                if (bool) {
                    const currentSymbol: TheRaveSymbol = TheRave.reels[index].getSymbol(1, true),
                        newSymbol: TheRaveSymbol = TheRave.reels[index].createSymbol("W", index, TheRaveSymbolState.NORMAL, currentSymbol.symbolHeight, true);

                    Logger.logDev("DOUBLE X-WAY RESTORE");
                    //TheRave.reels[index].doubleXwRestore();
                    newSymbol.position.set(2, 1);
                    TheRave.reels[index].removeOldSymbolOnFullWild(newSymbol, currentSymbol, 1);
                    TheRave.XWaysController.updateFullWildPosition(index);
                }
            });
        }
        TheRave.apiPlugin.events.on(APIEvent.ACTION_SPINS_IS_ACTIVE, (data: any) => {
            if (data === true) {
                TheRave.isActionSpinsActive = true;
                TheRave.individualWin.stop();
            } else {
                TheRave.isActionSpinsActive = false;
            }
        });
        /* TheRave.apiPlugin.events.on(APIEvent.BET_BOOST, (data: any) => {
             if (TheRave.apiPlugin.betHandler.betBoost !== undefined) {
                 TheRave.reels[1].reelView.showBoostFrame(false);
             } else {
                 TheRave.reels[1].reelView.hideBoostFrame(false);
             }
         });*/

        // If restore, can be handled here directly or do in the constructor when it's created here.
    }
}